import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import CustomFormCheck from "utils/CustomFormCheck";
import NumberDropdown from "utils/NumberDropdown";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function Permissions({
  setDevelopmentCapabilities,
  setCreativeCapabilities,
  permissionHandler,
  pageLocator,
  globalPermission,
  setGlobalPermission,
  isPermissionsEnabled,
  setIsPermissionsEnabled,
  customPermissions,
  setCustomPermissions,
  global_website_permissions,
  submitForm,
  onboarding_progress,
}) {
  pageLocator();

  const route = useContext(RouterContext);

  const nextPage = getNextPage(onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true && globalPermission) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  return (
    <>
      <Row className="mb-4 justify-content-center">
        <Col className=" d-flex flex-column align-items-center mb-2 pb-2 ">
          <div className="text-left">
          <div>
            <p className="pb-3 f28 visby-bold primary ">Capabilities and Permissions</p>
          </div>
          <div>
            <p className=" f16 pb-2 nunito-regular  primary ">What does the company's development team look like?</p>
          </div>
          <div>
            <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
            <Form.Control
              style={{ width: "360px" }}
              className="light-primary"
              as="select"
              size="md"
              defaultValue={""}
              onChange={(e) => setDevelopmentCapabilities(e.target.value)}
              required>
              <option value="" hidden disabled>
                Choose one
              </option>
              <option value="0">In-house full-time developers</option>
              <option value="1">Contracted developers part-time</option>
              <option value="2">None</option>
            </Form.Control>
          </div>
          <div>
            <p className=" f16 pb-2 mt-5 nunito-regular primary ">What does the company's creative team look like?</p>
          </div>
          <div>
            <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
            <Form.Control
              style={{ width: "360px" }}
              className="light-primary"
              as="select"
              size="md"
              defaultValue={""}
              onChange={(e) => setCreativeCapabilities(e.target.value)}
              required>
              <option value="" hidden disabled>
                Choose one
              </option>
              <option value="0">In-house full-time creative</option>
              <option value="1">Contracted creative part-time</option>
              <option value="2">None</option>
            </Form.Control>
          </div>
          </div>
        </Col>
      </Row>
      <Row className=" pb-3 justify-content-center">
        <Col className=" d-flex flex-column align-items-center mb-2 pb-2 ">
          <p className="visby-medium f18 ml-4 light-primary">Website Permissions</p>
        </Col>
      </Row>
      <Row className=" pb-3 mb-5 justify-content-center">
        <Col xl={6} lg={8} md={10} className=" d-flex flex-column p-2">
          <p className="nunito-regular f14 light-primary text-left">
            This is where you should dictate permissions in regards to what the marketing team can and cannot make changes to.{" "}
            <strong>
              It's important to review these options carefully, as the marketing team will reference these answers first before making changes to your web
              properties.
            </strong>
          </p>
          <br></br>
          <p className="nunito-regular f14 light-primary text-left">
            Make a global selection below to the left that best suits your preferences, and then customize any exceptions in the custom fields to the right. For
            example, if a client wants no changes made to the website but they are okay with changes to only content specifically, set the Global permissions to
            a 1, and then add 'Content' in the custom fields at a 2 or higher.
          </p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xl={6} lg={8} md={10} style={{ maxWidth: "100%" }}>
          <div>
            <Row style={{ paddingBottom: "30px" }} className="ml-0 trim-margin cp trim-padding justify-content-between">
              <Col xl={4} lg={6} md={12}>
                <p className="visby-bold f16 light-primary mb-3 text-left">Global permissions</p>

                <Row className="align-items-center" style={{ marginBottom: "10px" }}>
                  <Col className="col-1">
                    <Form.Check
                      name="global_website_permissions_temp"
                      value="4"
                      custom
                      label=""
                      type="radio"
                      id="globalperm4"
                      defaultChecked={global_website_permissions === 4 ? true : false}
                      onClick={() => setGlobalPermission(4)}
                    />
                  </Col>
                  <Col className="col-2">
                    {" "}
                    <span className="button-4">4</span>
                  </Col>
                  <Col>
                    <p className="permissions-text nunito-regular f12 light-primary mb-0 primary text-left">Free to make changes, no notification necessary</p>
                  </Col>
                </Row>
                <Row className="align-items-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                  <Col className="col-1">
                    <Form.Check
                      name="global_website_permissions_temp"
                      value="3"
                      custom
                      label=""
                      type="radio"
                      id="globalperm3"
                      defaultChecked={global_website_permissions === 3 ? true : false}
                      onClick={() => setGlobalPermission(3)}
                    />
                  </Col>
                  <Col className="col-2">
                    {" "}
                    <span className="button-3">3</span>
                  </Col>
                  <Col>
                    <p className="permissions-text nunito-regular f12 light-primary mb-0 primary text-left"> Free to make changes with follow-up email summary </p>
                  </Col>
                </Row>
                <Row className="align-items-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                  <Col className="col-1">
                    <Form.Check
                      name="global_website_permissions_temp"
                      value="2"
                      custom
                      label=""
                      type="radio"
                      id="globalperm2"
                      defaultChecked={global_website_permissions === 2 ? true : false}
                      onClick={() => setGlobalPermission(2)}
                    />
                  </Col>
                  <Col className="col-2">
                    {" "}
                    <span className="button-2">2</span>
                  </Col>
                  <Col>
                    <p className="permissions-text nunito-regular f12 light-primary mb-0 primary text-left">All changes require prior approval</p>
                  </Col>
                </Row>
                <Row className="align-items-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                  <Col className="col-1">
                    <Form.Check
                      name="global_website_permissions_temp"
                      value="1"
                      custom
                      label=""
                      type="radio"
                      id="globalperm1"
                      defaultChecked={global_website_permissions === 1 ? true : false}
                      onClick={() => setGlobalPermission(1)}
                    />
                  </Col>
                  <Col className="col-2">
                    {" "}
                    <span className="button-1">1</span>
                  </Col>
                  <Col>
                    <p className="permissions-text nunito-regular f12 light-primary mb-0 primary text-left">
                      {" "}
                      No changes allowed, or <br></br>exceptions only{" "}
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col xl={8} lg={6} md={12} style={{ textAlign: "center" }}>
                <p className="visby-bold f16 light-primary mb-3 text-left">
                  Custom permissions
                </p>
                <Row className=" mb-3 align-items-center" style={{ marginLeft: "30px" }}>
                  <CustomFormCheck
                    onChange={() => setIsPermissionsEnabled(!isPermissionsEnabled)}
                    id={"websitepermissionenable"}
                    checked={isPermissionsEnabled}
                    label="Enable"
                  />
                </Row>
                {customPermissions.map((item, idx) => {
                  return isPermissionsEnabled ? (
                    <Row key={item.id} className="mb-2 align-items-center flex-nowrap">
                      <Col xs={11}>
                        <Row>
                          <Col className="pr-0">
                            <Form.Control
                              disabled={!isPermissionsEnabled}
                              size="sm"
                              className="tableSearch mr-2 mb-2 py-0 col w-100"
                              style={{ minWidth: "100px" }}
                              placeholder=""
                              defaultValue={item.website}
                              required
                              onChange={(e) => {
                                let newRecipients = [...customPermissions];
                                newRecipients[idx].website = e.target.value;
                                setCustomPermissions(newRecipients);
                              }}
                            />
                          </Col>

                          <Col className="d-flex justify-content-around">
                            {" "}
                            <p style={{ whiteSpace: "nowrap" }} className="nunito-regular primary f12 mb-2 align-self-center mr-1">Set to: </p>{" "}

                            <NumberDropdown
                              item={idx + 1}
                              permission={parseInt(item.permission)}
                              setCustomPermissions={setCustomPermissions}
                              customPermissions={customPermissions}
                              idx={idx}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={1}>
                        {idx >= 0 && (
                          <i
                            onClick={() => {
                              const newPermissions = customPermissions.filter((el) => item.id !== el.id);
                              setCustomPermissions([...newPermissions]);
                            }}
                            className="mb-2  fas fa-minus-circle"></i>
                        )}
                      </Col>
                    </Row>
                  ) : null;
                })}

                <Row className="mt-3">
                  <Col xs={6}>
                    <Button
                      onClick={(e) => permissionHandler([...customPermissions, { id: uuidv4(), website: "", permission: 1 }])}
                      style={{ width: "120px", backgroundColor: isPermissionsEnabled ? undefined : "#70768F", cursor: isPermissionsEnabled ? undefined : "default" }}
                      className="mt-0 mb-2 btn-sm px-4 ml-2 text-center"
                      variant="success">
                      + Add field
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
